/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useReducer, useContext } from "react";
import Context from "../context/mainContext";
import { Action, ApiStateBase } from "../misc/api.types";
import { serviceReducerBase } from "./serviceReducer";

function useService<T>(func: () => Promise<T>): [T | null, boolean, (data: T) => void, () => void] {
  const mainContext = useContext(Context);

  const typedReducer = (st: ApiStateBase<T>, action: Action<T>) => serviceReducerBase(st, action);
  const [state, dispatch] = useReducer(typedReducer, {
    loading: false,
    data: null,
    trigger: false,
  });

  const setData = (data: T) => {
    dispatch({ type: "SUCCESS", payload: data });
  };
  const reload = () => {
    dispatch({ type: "RELOAD" });
  };

  useEffect(() => {
    let didCancel = false;

    const fetchData = async () => {
      dispatch({ type: "INIT" });
      try {
        const data = await func();
        if (!didCancel) {
          dispatch({ type: "SUCCESS", payload: data });
        }
      } catch (error) {
        if (!didCancel) {
          mainContext.notifyError(error as any);
          dispatch({ type: "FAIL" });
        }
      }
    };

    fetchData();
    return () => {
      didCancel = true;
    };
  }, [state.trigger]);

  return [state.data, state.loading, setData, reload];
}

export default useService;
